import { createContext, useContextSelector } from '@fluentui/react-context-selector';
import type { ContextSelector } from '@fluentui/react-context-selector';
import type { PromptStarterListContextValue } from '../PromptStarterList';

export const PromptStarterListContext = createContext<PromptStarterListContextValue | undefined>(undefined);

const promptStarterListContextDefaultValue: PromptStarterListContextValue = {
  numberOfColumns: 3,
};

export const usePromptStarterListContext = <T>(selector: ContextSelector<PromptStarterListContextValue, T>): T =>
  useContextSelector(PromptStarterListContext, (ctx = promptStarterListContextDefaultValue) => selector(ctx));
export const PromptStarterListProvider = PromptStarterListContext.Provider;
